import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Hardy Blend transformed our outdated website into a modern, high-converting platform. Their attention to detail is unmatched.',
  author: 'Sarah Johnson',
  role: 'Marketing Director',
  company: 'TechFlow Inc.'
}, {
  quote: 'The mobile app they developed for us has received outstanding reviews from our users. Professional, timely, and skilled team.',
  author: 'Michael Chen',
  role: 'CEO',
  company: 'StartUp Vision'
}, {
  quote: 'Great communication throughout the project. They understood our business needs and delivered a solution that exceeded expectations.',
  author: 'Emily Davis',
  role: 'Operations Manager',
  company: 'Global Logistics'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-20 bg-slate-900" data-id="element-292">
      <div className="container mx-auto px-4" data-id="element-293">
        <div className="text-center mb-16" data-id="element-294">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-295">
            Client Testimonials
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto" data-id="element-296"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-297">
          {testimonials.map((item, index) => <div key={index} className="bg-slate-800 p-8 rounded-xl border border-slate-700 relative" data-id="element-298">
              <Quote className="w-10 h-10 text-red-600/20 absolute top-6 right-6" data-id="element-299" />
              <p className="text-slate-300 italic mb-6 relative z-10" data-id="element-300">
                "{item.quote}"
              </p>
              <div data-id="element-301">
                <div className="font-bold text-white" data-id="element-302">{item.author}</div>
                <div className="text-sm text-red-500" data-id="element-303">{item.role}</div>
                <div className="text-xs text-slate-500" data-id="element-304">{item.company}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}